import React from 'react';
import PropTypes from 'prop-types';
import { ButtonLink, Notice, WarningNotice } from '@studio/legacy-components';

const PublishingBanner = ({
  disabled,
  published,
  hasChanges,
  onConfirmPublish,
  onConfirmDiscardChanges,
}) => {
  if (published && !hasChanges) {
    return (
      <Notice>
        This Experience is live! You can make changes and publish them when you
        are ready.
      </Notice>
    );
  }

  if (published && hasChanges) {
    if (disabled) {
      return (
        <WarningNotice>
          Heads up! You've made changes, but users won't see them until the
          changes are pushed.
        </WarningNotice>
      );
    }

    return (
      <WarningNotice>
        Heads up! You've made changes, but users won't see them until you hit{' '}
        <ButtonLink onClick={onConfirmPublish}>push changes</ButtonLink>. Or you
        can{' '}
        <ButtonLink onClick={onConfirmDiscardChanges}>
          discard changes
        </ButtonLink>{' '}
        via the dropdown.
      </WarningNotice>
    );
  }

  if (!published) {
    return (
      <WarningNotice>
        Changes made will not be shown to users until you publish them.
      </WarningNotice>
    );
  }

  return null;
};

PublishingBanner.propTypes = {
  disabled: PropTypes.bool,
  published: PropTypes.bool,
  hasChanges: PropTypes.bool,
  onConfirmPublish: PropTypes.func,
  onConfirmDiscardChanges: PropTypes.func,
};

export default PublishingBanner;
